
const searchRoutes = [
  {
    path: '/search/home',
    name: 'searchHome',
    component: () => import(/* webpackChunkName: "searchHome" */  '@/views/search/home/index.vue'),
    meta: {
      title: "搜零部件",
      keepAlive: true,
    },
  },
  {
    path: '/search/lib/:keyword',
    name: 'searchLib',
    component: () => import(/* webpackChunkName: "searchLib" */  '@/views/search/search-lib/index.vue'),
    meta: {
      title: "搜索列表",
    },
  },
  {
    path: '/search/comp/:keyword',
    name: 'searchComp',
    component: () => import(/* webpackChunkName: "searchLib" */  '@/views/search/search-comp/search-comp.vue'),
    meta: {
      title: "搜索企业",
    },
  },
  // 搜索产品为空时
  {
    path: '/search/lib',
    redirect: () => {
      return { path: '/search/home' }
    },
  },
  // 几何搜索
  {
    path: '/search/geometric',
    name: 'searchGeometric',
    component: () => import(/* webpackChunkName: "searchGeometric" */  '@/views/search/search-geometric/index.vue'),
    meta: {
      title: "模型智能检索",
    },
  },
];

export default searchRoutes;
